import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

import Box from '@mui/material/Box';

// project import
import Footer from './Footer';
import Loader from 'components/Loader';
import HeaderContent from 'components/@extended/HeaderContent';
import { getPageHeaderTitle } from 'utils/pageTitle';
import AuthGuard from 'utils/route-guard/AuthGuard';
import useAuthenticatedRequest from 'hooks/useAuthenticatedRequest';
import { useGetMenuMaster } from 'api/menu';
import { Divider, Grid, Typography } from '@mui/material';
import MainContainer from 'components/@extended/MainContainer';
import RedesignShell from 'components/redesign/RedesignShell';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { user, isLoaded, isSignedIn } = useUser();
  const publicMetadata = user && user.publicMetadata;
  // const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState(false);
  const pageTitle = getPageHeaderTitle();
  const { makeAuthenticatedRequest } = useAuthenticatedRequest();
  const navigate = useNavigate();
  const location = useLocation();
  const DEBUG_AUTH = Boolean(import.meta.env.VITE_DEBUG_AUTH);

  useEffect(() => {
    const lastPath = localStorage.getItem('lastPath');
    if (lastPath && lastPath !== '/') {
      navigate(lastPath);
    }
  }, []);

  useEffect(() => {
    if (!isLoaded || !isSignedIn) return;
    let cancelled = false;
    const fetchUserProfile = async () => {
      try {
        const data = await makeAuthenticatedRequest('/api/v1/account/usersubscription/me/', { method: 'GET', timeout: 8000 });
        if (!cancelled) {
          if (DEBUG_AUTH) console.log('User subscription data:', data);
          // setUserType(data);
        }
      } catch (error) {
        if (!cancelled && DEBUG_AUTH) console.warn('User subscription fetch failed:', error?.message || error);
      }
    };
    fetchUserProfile();
    return () => { cancelled = true; };
  }, [makeAuthenticatedRequest, isLoaded, isSignedIn]);

  useEffect(() => {
    if (publicMetadata) {
      setUserType(JSON.stringify(publicMetadata));
    }

  }, [publicMetadata]);
  const roleType = (() => { try { return userType ? JSON.parse(userType) : {}; } catch { return {}; } })();

  const { menuMasterLoading } = useGetMenuMaster();

  if (menuMasterLoading) return <Loader />;

  // Pages that own the redesigned application shell must bypass the legacy
  // Dashboard chrome. Wrapping one of these routes in another RedesignShell
  // produces the visible "dashboard inside a dashboard" defect.
  const shellOwningRoutes = ['/dashboard', '/tradingcycle', '/performance', '/performance-dashboard', '/journal', '/view-profile'];
  if (shellOwningRoutes.includes(location.pathname.replace(/\/$/, '') || '/')) {
    return <AuthGuard><Outlet /></AuthGuard>;
  }

  return (
    <AuthGuard>
      {/* Advertising banner disabled */}
      {null}
      <RedesignShell>
        <Box component="main" sx={{ width: '100%', p: { xs: 2.5, md: '34px 40px 48px' } }}>

          <MainContainer sx={{ top: '0px', left: 0 }}>
            <Grid container alignItems={'center'}>
              <Grid item xs={12} md={4}>
                <Typography variant={'h2'}>{pageTitle}</Typography>
              </Grid>
              <Grid item xs={12} sm={8} alignItems={'center'}>
                <HeaderContent userType={roleType && roleType.membership} />
              </Grid>
            </Grid>
            <Divider sx={{ mt: 2, mb: 3 }} />
          </MainContainer>
          <Outlet />
          <Footer />

        </Box>
      </RedesignShell>
    </AuthGuard>
  );
}
